// import React, { useState, useEffect, useRef } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import carpark1 from '@/assets/img/car-park-1.png';
// import jeddhalogo from '@/assets/img/Jubail.png';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import ErrorState from '@/components/common/ErrorStateComponent';
// import { useQueue } from '@/context/QueueContext';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ─── Fallback Data ───────────────────────────────────────────────────────────
// const fallbackTables = [
//   {
//     table_key: 'lovers_market_profile',
//     title: 'Lovers Market Parking Profile',
//     data: {
//       car_park_bays: { label: 'Total Off Street Car Park Bays', value: 520 },
//       contract_term: { label: 'Contract Term', value: '25 years' },
//       contract_period: { start_date: '02.08.2021', end_date: '02.11.2045' },
//       operational_hours: { label: 'Operational Hours', value: '24 Hours' },
//       vat_note: { label: 'Parking Charges', value: 'SAR 03 including 15% VAT' },
//     },
//   },
//   {
//     table_key: 'lovers_market_parking_bays_breakdown',
//     title: 'Lovers Market Parking Bays Breakdown',
//     data: {
//       columns: ['LOVERS MARKET PARKING BAYS', '520'],
//       rows: [
//         ['LOVERS MARKET PARKING BAYS', '520'],
//         ['PARKING AREA 1', '140'],
//         ['PARKING AREA 2', 'Closed'],
//         ['PARKING AREA 3', '64'],
//         ['PARKING AREA 4', '70'],
//         ['PARKING AREA 5', 'Closed'],
//         ['PARKING AREA 6', 'Closed'],
//         ['PARKING AREA 7', '28'],
//         ['PARKING AREA 8', '56'],
//       ],
//     },
//   },
//   {
//     table_key: 'lovers_market_assets_deployed',
//     title: 'Lovers Market Dammam Off-Street',
//     data: {
//       groups: [
//         { group_name: 'Ticket Dispenser', group_total_qty: '9', items: [{ item_name: 'DIP G100', qty: '9' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//         { group_name: 'Ticket Verifier', group_total_qty: '9', items: [{ item_name: 'EV DIP G100', qty: '9' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//         { group_name: "APM's", group_total_qty: '9', items: [{ item_name: 'APM ETS-70', qty: '9' }, { item_name: 'APM ETS-100', qty: '-' }] },
//         { group_name: 'PIN Pad', group_total_qty: '18', items: [{ item_name: 'IUP250', qty: '18' }] },
//         { group_name: 'Card Reader', group_total_qty: '9', items: [{ item_name: 'IUR250', qty: '9' }] },
//         { group_name: 'B-Contactless', group_total_qty: '18', items: [{ item_name: 'IUC150', qty: '18' }] },
//         { group_name: 'RFID Reader', group_total_qty: '19', },
//         { group_name: 'IP Barrier', group_total_qty: '18', },
//         { group_name: 'ANPR CAMERA', group_total_qty: '18', items: [{ item_name: 'ARH', qty: '18' },{ item_name: 'Luminnera', qty: '-' },]},
//         { group_name: 'Sliding Gate', group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//         { group_name: "PND's", group_total_qty: '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//         { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//         { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
//         { group_name: 'Enf Device', group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//         { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenovo Tablet', qty: '-' }, ] },
//         { group_name: 'Printer', group_total_qty: '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }, ] },
//         { group_name: 'TOW Truck', group_total_qty: '-', },
//         { group_name: 'Clamp Vehicle', group_total_qty: '-', },
//         { group_name: 'Support Vehicle', group_total_qty: '1', },
//       ],
//     },
//   },
// ];

// // ─── Helpers ────────────────────────────────────────────────────────────────
// const getByKey = (tables, key) =>
//   tables.find(t => t.table_key === key) || fallbackTables.find(t => t.table_key === key);

// // ─── Main Component (Wrapper) ───────────────────────────────────────────────
// const LoversMarket_2 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
//   const { enqueue } = useQueue();
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         setProfileData(null);

//         const response = await enqueue(() =>
//           apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })
//         );

//         if (!response?.success) throw new Error(response?.message || 'API returned unsuccessful response');

//         const rawApiData = Array.isArray(response?.data) && response.data.length > 0
//           ? response.data
//           : fallbackTables;

//         const normalizedData = transformApiDataToComponentFormat(rawApiData);
//         setProfileData(normalizedData);
//       } catch (err) {
//         console.error('Error fetching lovers market data:', err);
//         setError(err.message || 'Failed to load data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [year, monthNumber, contract]);

//   // Transform API data to component-friendly format
//   const transformApiDataToComponentFormat = (apiData) => {
//     const profileTable = getByKey(apiData, 'lovers_market_profile');
//     const baysTable = getByKey(apiData, 'lovers_market_parking_bays_breakdown');
//     const assetsTable = getByKey(apiData, 'lovers_market_assets_deployed');

//     const profileData_ = profileTable?.data || {};
//     const baysData = baysTable?.data || {};
//     const assetsData = assetsTable?.data || {};

//     return {
//       title: profileTable?.title || 'Lovers Market Parking Profile',
//       totalBays: profileData_?.car_park_bays?.value || 0,
//       contractInfo: {
//         duration: profileData_?.contract_term?.value || '',
//         startDate: profileData_?.contract_period?.start_date || '',
//         endDate: profileData_?.contract_period?.end_date || '',
//         operationalHours: profileData_?.operational_hours?.value || '',
//         vatNote: profileData_?.vat_note?.value || '',
//       },
//       parkingBays: (baysData?.rows || []).map(row => ({
//         name: row[0],
//         count: row[1],
//       })),
//       assetsDeployed: transformAssetsDeployed(assetsData?.groups || []),
//       assetsTitle: assetsTable?.title || 'Lovers Market Dammam Off-Street',
//     };
//   };

//   const transformAssetsDeployed = (groups) => {
//     const result = [];
//     groups.forEach(group => {
//       result.push({
//         name: group.group_name || '',
//         isCategory: true,
//         isBold: true,
//         subCount: '',
//         totalCount: group.group_total_qty != null ? String(group.group_total_qty) : '',
//       });
//       (group.items || []).forEach(item => {
//         result.push({
//           name: item.item_name || '',
//           isCategory: false,
//           subCount: item.qty != null ? String(item.qty) : '-',
//           totalCount: '',
//         });
//       });
//     });
//     return result;
//   };

//   if (loading) return <LoadingComponent />;
//   if (error) return <ErrorState error={error} />;

//   return (
//     <LoversMarketComponent2
//       profileData={profileData}
//       year={year}
//       monthNumber={monthNumber}
//       contract={contract}
//     />
//   );
// };

// // ─── Editable Component (Main UI with uncontrolled refs) ─────────────────────
// const LoversMarketComponent2 = ({ profileData, year, monthNumber, contract }) => {
//   const [data, _setData] = useState(profileData);
//   const dataRef = useRef(profileData);
//   const [isSaving, setIsSaving] = useState(false);
//   const saveTimeoutRef = useRef(null);

//   // Refs for all inputs
//   const totalBaysRef = useRef(null);
//   const parkingBayNameRefs = useRef([]);
//   const parkingBayCountRefs = useRef([]);
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);
  
//   // Contract info refs
//   const contractDurationRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
//   const contractOperationalHoursRef = useRef(null);
//   const contractVatNoteRef = useRef(null);

//   const setData = (valOrFn) => {
//     _setData(prev => {
//       const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//       dataRef.current = next;
//       return next;
//     });
//   };

//   useEffect(() => {
//     if (profileData) {
//       _setData(profileData);
//       dataRef.current = profileData;
//     }
//   }, [profileData]);

//   const {
//     title = 'Lovers Market Parking Profile',
//     totalBays = 0,
//     contractInfo = {},
//     parkingBays = [],
//     assetsDeployed = [],
//     assetsTitle = '',
//   } = data || {};

//   const autoSave = () => {
//     if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
//     saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   // Build API Payload
//   const transformToApiFormat = () => {
//     const currentTotalBays = totalBaysRef.current?.value ?? totalBays;
//     const currentDuration = contractDurationRef.current?.value ?? contractInfo.duration;
//     const currentStartDate = contractStartDateRef.current?.value ?? contractInfo.startDate;
//     const currentEndDate = contractEndDateRef.current?.value ?? contractInfo.endDate;
//     const currentOperationalHours = contractOperationalHoursRef.current?.value ?? contractInfo.operationalHours;
//     const currentVatNote = contractVatNoteRef.current?.value ?? contractInfo.vatNote;

//     return {
//       contract,
//       year,
//       month: monthNumber,
//       created_by: 1,
//       tables: [
//         {
//           table_key: 'lovers_market_profile',
//           title: 'Lovers Market Parking Profile',
//           data: {
//             car_park_bays: { label: 'Total Off Street Car Park Bays', value: currentTotalBays },
//             contract_term: { label: 'Contract Term', value: currentDuration || '' },
//             contract_period: {
//               start_date: currentStartDate || '',
//               end_date: currentEndDate || '',
//             },
//             operational_hours: { label: 'Operational Hours', value: currentOperationalHours || '' },
//             vat_note: { label: 'Parking Charges', value: currentVatNote || '' },
//           },
//         },
//         {
//           table_key: 'lovers_market_parking_bays_breakdown',
//           title: 'Lovers Market Parking Bays Breakdown',
//           data: {
//             columns: ['LOVERS MARKET PARKING BAYS', String(currentTotalBays)],
//             rows: parkingBays.map((bay, i) => [
//               parkingBayNameRefs.current[i]?.value ?? bay.name,
//               parkingBayCountRefs.current[i]?.value ?? bay.count,
//             ]),
//           },
//         },
//         {
//           table_key: 'lovers_market_assets_deployed',
//           title: assetsTitle,
//           data: {
//             groups: transformAssetsToApiFormat(),
//           },
//         },
//       ],
//     };
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = dataRef.current?.assetsDeployed || assetsDeployed;
//     const groups = [];
//     let currentGroup = null;

//     currentAssets.forEach((asset, i) => {
//       if (asset.isCategory) {
//         if (currentGroup) groups.push(currentGroup);
//         const totalVal = assetTotalCountRefs.current[i]?.value;
//         currentGroup = {
//           group_name: asset.name,
//           group_total_qty: totalVal !== undefined ? totalVal : (asset.totalCount || '-'),
//           items: [],
//         };
//       } else if (currentGroup) {
//         const qty = assetSubCountRefs.current[i]?.value ?? asset.subCount ?? '-';
//         currentGroup.items.push({
//           item_name: asset.name,
//           qty: qty === '' ? '-' : qty,
//         });
//       }
//     });

//     if (currentGroup) groups.push(currentGroup);
//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
//       const payload = transformToApiFormat();
//       const response = await apiCall('POST', '/boardpack/add-tables-data', payload);

//       if (!response?.success) throw new Error(response?.message || 'Failed to update data');
//       // toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Error saving data:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const editableClass = "w-full !border-0 !border-b !border-gray-300 focus:!border-blue-500 px-1 bg-transparent transition-colors outline-none text-[10px] md:text-[11px]";

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8">
//       {/* Header */}
//       <div className="text-center mb-2 py-0.5 flex justify-between items-center">
//         <div className="ml-2">
//           <img src={jeddhalogo} alt="Logo" style={{ width: '100%', height: '50px', objectFit: 'cover' }} />
//         </div>
//         <h1 className="text-2xl font-bold leading-tight flex-1 text-center">
//           {title}
//         </h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-6 !border-2 !border-black p-4">
//         {/* Left Column */}
//         <div className="lg:flex-1">
//           {/* Top Info - All uncontrolled now */}
//           <div className="p-3 mb-6">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-[34px] h-[34px] flex-shrink-0">
//                 <img src={carpark1} alt="Car Park" className="w-full h-full object-contain" />
//               </div>
//               <div className="flex items-center gap-2 flex-wrap">
//                 <span className="text-[14px] text-gray-700">Total Off Street Car Park Bays</span>
//                 <strong>
//                   <input
//                     type="text"
//                     defaultValue={totalBays}
//                     ref={totalBaysRef}
//                     onChange={autoSave}
//                     className="text-[14px] font-bold w-20 outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500"
//                   />
//                 </strong>
//               </div>
//             </div>

//             <div className="space-y-1.5 ml-10 text-[10px] md:text-[11px] leading-tight">
//               <div className="flex items-start">
//                 <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 <span className="inline-flex items-center gap-1.5 flex-wrap">
//                   Contract term{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={contractInfo.duration || ''}
//                       ref={contractDurationRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-24"
//                     />
//                   </strong>
//                   ; start date{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={contractInfo.startDate || ''}
//                       ref={contractStartDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-24"
//                     />
//                   </strong>
//                   to{' '}
//                   <strong>
//                     <input
//                       type="text"
//                       defaultValue={contractInfo.endDate || ''}
//                       ref={contractEndDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-24"
//                     />
//                   </strong>
//                 </span>
//               </div>

//               <div className="flex items-start">
//                 <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 Operational Hours –{' '}
//                 <strong>
//                   <input
//                     type="text"
//                     defaultValue={contractInfo.operationalHours || ''}
//                     ref={contractOperationalHoursRef}
//                     onChange={autoSave}
//                     className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-32"
//                   />
//                 </strong>
//               </div>

//               <div className="flex items-start">
//                 <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 Parking Charges –{' '}
//                 <strong>
//                   <input
//                     type="text"
//                     defaultValue={contractInfo.vatNote || ''}
//                     ref={contractVatNoteRef}
//                     onChange={autoSave}
//                     className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-48"
//                   />
//                 </strong>
//               </div>

//               <div className="flex items-center gap-2 mt-2">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[11px]">Assets Deployed</span>
//               </div>
//             </div>
//           </div>

//           {/* Parking Bays Table */}
//           <div className="!border !border-black overflow-hidden max-w-[450px]">
//             <table className="w-full !border-collapse text-[9px] md:text-[10px]">
//               <tbody>
//                 {/* <tr className="bg-gray-300">
//                   <td className="p-2 font-black !border-r !border-black text-center">LOVERS MARKET PARKING BAYS</td>
//                   <td className="p-2 text-center font-black w-28 !border-black">
//                     <input
//                       type="text"
//                       defaultValue={totalBays}
//                       ref={totalBaysRef}
//                       onChange={autoSave}
//                       className="w-full text-center font-black outline-none bg-transparent border-0"
//                     />
//                   </td>
//                 </tr> */}
//                 {parkingBays.map((bay, index) => (
//                   <tr key={index} className={`${index === 0 && "!border-b-2 font-black"} !border-b !border-black`}>
//                     <td className="p-2 !border-r !border-black text-center font-semibold">
//                       <input
//                         type="text"
//                         defaultValue={bay.name}
//                         ref={(el) => (parkingBayNameRefs.current[index] = el)}
//                         onChange={autoSave}
//                         className="w-full text-center outline-none bg-transparent !border-0 font-semibold"
//                       />
//                     </td>
//                     <td className="p-2 text-center w-28">
//                       <input
//                         type="text"
//                         defaultValue={bay.count}
//                         ref={(el) => (parkingBayCountRefs.current[index] = el)}
//                         onChange={autoSave}
//                         className="w-full text-center outline-none bg-transparent !border-0"
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Right Column - Assets Panel */}
//         <div className="flex items-start">
//           <AssetsPanel
//             assetsTable={{ title: assetsTitle }}
//             flatAssets={assetsDeployed}
//             subCountRefs={assetSubCountRefs}
//             totalCountRefs={assetTotalCountRefs}
//             onSubCount={(index, value) => {
//               setData(prev => {
//                 const updatedAssets = [...prev.assetsDeployed];
//                 updatedAssets[index] = { ...updatedAssets[index], subCount: value };
//                 return { ...prev, assetsDeployed: updatedAssets };
//               });
//               autoSave();
//             }}
//             onTotalCount={(index, value) => {
//               setData(prev => {
//                 const updatedAssets = [...prev.assetsDeployed];
//                 updatedAssets[index] = { ...updatedAssets[index], totalCount: value };
//                 return { ...prev, assetsDeployed: updatedAssets };
//               });
//               autoSave();
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoversMarket_2;




import React, { useState, useEffect, useRef } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import carpark1 from '@/assets/img/car-park-1.png';
import jeddhalogo from '@/assets/img/Jubail.png';
import LoadingComponent from '@/components/common/LoadingComponent';
import ErrorState from '@/components/common/ErrorStateComponent';
import { useQueue } from '@/context/QueueContext';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ─── Fallback Data ───────────────────────────────────────────────────────────
const fallbackTables = [
  {
    table_key: 'lovers_market_profile',
    title: 'Lovers Market Parking Profile',
    data: {
      car_park_bays: { label: 'Total Off Street Car Park Bays', value: 520 },
      contract_term: { label: 'Contract Term', value: '25 years' },
      contract_period: { start_date: '02.08.2021', end_date: '02.11.2045' },
      operational_hours: { label: 'Operational Hours', value: '24 Hours' },
      vat_note: { label: 'Parking Charges', value: 'SAR 03 including 15% VAT' },
    },
  },
  {
    table_key: 'lovers_market_parking_bays_breakdown',
    title: 'Lovers Market Parking Bays Breakdown',
    data: {
      columns: ['LOVERS MARKET PARKING BAYS', '520'],
      rows: [
        ['LOVERS MARKET PARKING BAYS', '520'],
        ['PARKING AREA 1', '140'],
        ['PARKING AREA 2', 'Closed'],
        ['PARKING AREA 3', '64'],
        ['PARKING AREA 4', '70'],
        ['PARKING AREA 5', 'Closed'],
        ['PARKING AREA 6', 'Closed'],
        ['PARKING AREA 7', '28'],
        ['PARKING AREA 8', '56'],
      ],
    },
  },
  {
    table_key: 'lovers_market_assets_deployed',
    title: 'Lovers Market Dammam Off-Street',
    data: {
      groups: [
        { group_name: 'Ticket Dispenser', group_total_qty: '9', items: [{ item_name: 'DIP G100', qty: '9' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
        { group_name: 'Ticket Verifier', group_total_qty: '9', items: [{ item_name: 'EV DIP G100', qty: '9' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
        { group_name: "APM's", group_total_qty: '9', items: [{ item_name: 'APM ETS-70', qty: '9' }, { item_name: 'APM ETS-100', qty: '-' }] },
        { group_name: 'PIN Pad', group_total_qty: '18', items: [{ item_name: 'IUP250', qty: '18' }] },
        { group_name: 'Card Reader', group_total_qty: '9', items: [{ item_name: 'IUR250', qty: '9' }] },
        { group_name: 'B-Contactless', group_total_qty: '18', items: [{ item_name: 'IUC150', qty: '18' }] },
        { group_name: 'RFID Reader', group_total_qty: '19', },
        { group_name: 'IP Barrier', group_total_qty: '18', },
        { group_name: 'ANPR CAMERA', group_total_qty: '18', items: [{ item_name: 'ARH', qty: '18' },{ item_name: 'Luminnera', qty: '-' },]},
        { group_name: 'Sliding Gate', group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
        { group_name: "PND's", group_total_qty: '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
        { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
        { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
        { group_name: 'Enf Device', group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
        { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenovo Tablet', qty: '-' }, ] },
        { group_name: 'Printer', group_total_qty: '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }, ] },
        { group_name: 'TOW Truck', group_total_qty: '-', },
        { group_name: 'Clamp Vehicle', group_total_qty: '-', },
        { group_name: 'Support Vehicle', group_total_qty: '1', },
      ],
    },
  },
];

// ─── Helpers ────────────────────────────────────────────────────────────────
const getByKey = (tables, key) =>
  tables.find(t => t.table_key === key) || fallbackTables.find(t => t.table_key === key);

// ─── Main Component (Wrapper) ───────────────────────────────────────────────
const LoversMarket_2 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
  const { enqueue } = useQueue();
  const [profileData, setProfileData] = useState(null);
  const [parkingBaysData, setParkingBaysData] = useState(null); // 🔥 New state for second API
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "0030015",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (!firstApiResponse?.success) {
        throw new Error(firstApiResponse?.message || 'API returned unsuccessful response');
      }

      const rawApiData = Array.isArray(firstApiResponse?.data) && firstApiResponse.data.length > 0
        ? firstApiResponse.data
        : fallbackTables;

      const normalizedData = transformApiDataToComponentFormat(rawApiData);
      setProfileData(normalizedData);

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Error fetching lovers market data:', err);
      setError(err.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  // Transform API data to component-friendly format
  const transformApiDataToComponentFormat = (apiData) => {
    const profileTable = getByKey(apiData, 'lovers_market_profile');
    const baysTable = getByKey(apiData, 'lovers_market_parking_bays_breakdown');
    const assetsTable = getByKey(apiData, 'lovers_market_assets_deployed');

    const profileData_ = profileTable?.data || {};
    const baysData = baysTable?.data || {};
    const assetsData = assetsTable?.data || {};

    return {
      title: profileTable?.title || 'Lovers Market Parking Profile',
      totalBays: profileData_?.car_park_bays?.value || 0,
      contractInfo: {
        duration: profileData_?.contract_term?.value || '',
        startDate: profileData_?.contract_period?.start_date || '',
        endDate: profileData_?.contract_period?.end_date || '',
        operationalHours: profileData_?.operational_hours?.value || '',
        vatNote: profileData_?.vat_note?.value || '',
      },
      parkingBays: (baysData?.rows || []).map(row => ({
        name: row[0],
        count: row[1],
      })),
      assetsDeployed: transformAssetsDeployed(assetsData?.groups || []),
      assetsTitle: assetsTable?.title || 'Lovers Market Dammam Off-Street',
    };
  };

  const transformAssetsDeployed = (groups) => {
    const result = [];
    groups.forEach(group => {
      result.push({
        name: group.group_name || '',
        isCategory: true,
        isBold: true,
        subCount: '',
        totalCount: group.group_total_qty != null ? String(group.group_total_qty) : '',
      });
      (group.items || []).forEach(item => {
        result.push({
          name: item.item_name || '',
          isCategory: false,
          subCount: item.qty != null ? String(item.qty) : '-',
          totalCount: '',
        });
      });
    });
    return result;
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} />;

  return (
    <LoversMarketComponent2
      profileData={profileData}
      parkingBaysData={parkingBaysData}  // 🔥 Pass second API data
      year={year}
      monthNumber={monthNumber}
      contract={contract}
    />
  );
};

// ─── Editable Component (Main UI with uncontrolled refs) ─────────────────────
const LoversMarketComponent2 = ({ profileData, parkingBaysData, year, monthNumber, contract }) => {
  const [data, _setData] = useState(profileData);
  const dataRef = useRef(profileData);
  const [isSaving, setIsSaving] = useState(false);
  const saveTimeoutRef = useRef(null);

  // 🔥 Use parkingBaysData ka total_bays (READ ONLY - second API se aaya hai)
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileData?.totalBays ?? 0;

  // Refs for all inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const parkingBayNameRefs = useRef([]);
  const parkingBayCountRefs = useRef([]);
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);
  
  // Contract info refs
  const contractDurationRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const contractOperationalHoursRef = useRef(null);
  const contractVatNoteRef = useRef(null);

  const setData = (valOrFn) => {
    _setData(prev => {
      const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      dataRef.current = next;
      return next;
    });
  };

  useEffect(() => {
    if (profileData) {
      _setData(profileData);
      dataRef.current = profileData;
    }
  }, [profileData]);

  const {
    title = 'Lovers Market Parking Profile',
    contractInfo = {},
    parkingBays = [],
    assetsDeployed = [],
    assetsTitle = '',
  } = data || {};

  const autoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // Build API Payload
  const transformToApiFormat = () => {
    // 🔥 totalBays - ab read-only value use karo
    const currentTotalBays = effectiveTotalBays;
    const currentDuration = contractDurationRef.current?.value ?? contractInfo.duration;
    const currentStartDate = contractStartDateRef.current?.value ?? contractInfo.startDate;
    const currentEndDate = contractEndDateRef.current?.value ?? contractInfo.endDate;
    const currentOperationalHours = contractOperationalHoursRef.current?.value ?? contractInfo.operationalHours;
    const currentVatNote = contractVatNoteRef.current?.value ?? contractInfo.vatNote;

    return {
      contract,
      year,
      month: monthNumber,
      created_by: 1,
      tables: [
        {
          table_key: 'lovers_market_profile',
          title: 'Lovers Market Parking Profile',
          data: {
            car_park_bays: { label: 'Total Off Street Car Park Bays', value: currentTotalBays },
            contract_term: { label: 'Contract Term', value: currentDuration || '' },
            contract_period: {
              start_date: currentStartDate || '',
              end_date: currentEndDate || '',
            },
            operational_hours: { label: 'Operational Hours', value: currentOperationalHours || '' },
            vat_note: { label: 'Parking Charges', value: currentVatNote || '' },
          },
        },
        {
          table_key: 'lovers_market_parking_bays_breakdown',
          title: 'Lovers Market Parking Bays Breakdown',
          data: {
            columns: ['LOVERS MARKET PARKING BAYS', String(currentTotalBays)],
            rows: parkingBays.map((bay, i) => [
              parkingBayNameRefs.current[i]?.value ?? bay.name,
              parkingBayCountRefs.current[i]?.value ?? bay.count,
            ]),
          },
        },
        {
          table_key: 'lovers_market_assets_deployed',
          title: assetsTitle,
          data: {
            groups: transformAssetsToApiFormat(),
          },
        },
      ],
    };
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = dataRef.current?.assetsDeployed || assetsDeployed;
    const groups = [];
    let currentGroup = null;

    currentAssets.forEach((asset, i) => {
      if (asset.isCategory) {
        if (currentGroup) groups.push(currentGroup);
        const totalVal = assetTotalCountRefs.current[i]?.value;
        currentGroup = {
          group_name: asset.name,
          group_total_qty: totalVal !== undefined ? totalVal : (asset.totalCount || '-'),
          items: [],
        };
      } else if (currentGroup) {
        const qty = assetSubCountRefs.current[i]?.value ?? asset.subCount ?? '-';
        currentGroup.items.push({
          item_name: asset.name,
          qty: qty === '' ? '-' : qty,
        });
      }
    });

    if (currentGroup) groups.push(currentGroup);
    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      const payload = transformToApiFormat();
      const response = await apiCall('POST', '/boardpack/add-tables-data', payload);

      if (!response?.success) throw new Error(response?.message || 'Failed to update data');
    } catch (err) {
      console.error('Error saving data:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  const editableClass = "w-full !border-0 !border-b !border-gray-300 focus:!border-blue-500 px-1 bg-transparent transition-colors outline-none text-[11px]";

  return (
    <div className="min-h-screen p-8">
      {/* Header */}
      <div className="text-center mb-2 py-0.5 flex justify-between items-center">
        <div className="ml-2">
          <img src={jeddhalogo} alt="Logo" style={{ width: '100%', height: '50px', objectFit: 'cover' }} />
        </div>
        <h1 className="text-2xl font-bold leading-tight flex-1 text-center">
          {title}
        </h1>
      </div>

      <div className="flex flex-row gap-6 !border-2 !border-black p-4">
        {/* Left Column */}
        <div className="flex-1">
          {/* Top Info - All uncontrolled now */}
          <div className="p-3 mb-6">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-[34px] h-[34px] flex-shrink-0">
                <img src={carpark1} alt="Car Park" className="w-full h-full object-contain" />
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-[14px] text-gray-700">Total Off Street Car Park Bays</span>
                {/* 🔥 READ-ONLY - Second API se aayega */}
                <strong>
                  <input
                    type="text"
                    value={effectiveTotalBays}
                    readOnly
                    disabled
                    className="text-[14px] font-bold w-20 outline-none bg-transparent !border-0 cursor-default"
                  />
                </strong>
              </div>
            </div>

            <div className="space-y-1.5 ml-10 text-[11px] leading-tight">
              <div className="flex items-start">
                <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                <span className="inline-flex items-center gap-1.5 flex-wrap">
                  Contract term{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={contractInfo.duration || ''}
                      ref={contractDurationRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-12"
                    />
                  </strong>
                  ; start date{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={contractInfo.startDate || ''}
                      ref={contractStartDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-16"
                    />
                  </strong>
                  to{' '}
                  <strong>
                    <input
                      type="text"
                      defaultValue={contractInfo.endDate || ''}
                      ref={contractEndDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-18"
                    />
                  </strong>
                </span>
              </div>

              <div className="flex items-start">
                <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                Operational Hours –{' '}
                <strong>
                  <input
                    type="text"
                    defaultValue={contractInfo.operationalHours || ''}
                    ref={contractOperationalHoursRef}
                    onChange={autoSave}
                    className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-32"
                  />
                </strong>
              </div>

              <div className="flex items-start">
                <div className="mr-1 mt-0.5 w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                Parking Charges –{' '}
                <strong>
                  <input
                    type="text"
                    defaultValue={contractInfo.vatNote || ''}
                    ref={contractVatNoteRef}
                    onChange={autoSave}
                    className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 w-48"
                  />
                </strong>
              </div>

              <div className="flex items-center gap-2 mt-2">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[11px]">Assets Deployed</span>
              </div>
            </div>
          </div>

          {/* Parking Bays Table - Individual bays EDITABLE */}
          <div className="!border !border-black overflow-hidden max-w-[450px]">
            <table className="w-full !border-collapse text-[10px]">
              <tbody>
                {parkingBays.map((bay, index) => (
                  <tr key={index} className={`${index === 0 && "!border-b-2 font-black"} !border-b !border-black`}>
                    <td className="p-2 !border-r !border-black text-center font-semibold">
                      <input
                        type="text"
                        defaultValue={bay.name}
                        ref={(el) => (parkingBayNameRefs.current[index] = el)}
                        onChange={autoSave}
                        className="w-full text-center outline-none bg-transparent !border-0 font-semibold"
                      />
                    </td>
                    <td className="p-2 text-center w-28">
                      <input
                        type="text"
                        defaultValue={bay.count}
                        ref={(el) => (parkingBayCountRefs.current[index] = el)}
                        onChange={autoSave}
                        className="w-full text-center outline-none bg-transparent !border-0"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Right Column - Assets Panel */}
        <div className="flex items-start">
          <AssetsPanel
            assetsTable={{ title: assetsTitle }}
            flatAssets={assetsDeployed}
            subCountRefs={assetSubCountRefs}
            totalCountRefs={assetTotalCountRefs}
            onSubCount={(index, value) => {
              setData(prev => {
                const updatedAssets = [...prev.assetsDeployed];
                updatedAssets[index] = { ...updatedAssets[index], subCount: value };
                return { ...prev, assetsDeployed: updatedAssets };
              });
              autoSave();
            }}
            onTotalCount={(index, value) => {
              setData(prev => {
                const updatedAssets = [...prev.assetsDeployed];
                updatedAssets[index] = { ...updatedAssets[index], totalCount: value };
                return { ...prev, assetsDeployed: updatedAssets };
              });
              autoSave();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoversMarket_2;